module.exports = __webpack_public_path__ + "static/media/1.3913ab82.jpg";